import React, { useState } from "react";
import Lottie from "react-lottie-player";
import { isMobileDevice } from "../../../../../utils/getPlatformInfo";
import styles from "./BannerLottie.module.scss";

const segmentData = {
  handleBtn: [
    {
      start: 0,
      end: 0,
    },
  ],
};

const BannerLottie = ({
  eventDetails,
  customClass,
  animationData = { json: false },
}) => {
  const [segmentFrom, setSegmentFrom] = useState(
    segmentData.handleBtn[0].start
  );

  const [segmentTo, setSegmentTo] = useState(segmentData.handleBtn[0].end);
  const [segmentsEnabled, setSegmentsEnabled] = useState(true);
  const [play, setPlay] = useState(true);
  const [loop, setLoop] = useState(true);
  const [speed, setSpeed] = useState(1);
  const [goTo, setGoTo] = useState(0);
  const [direction, setDirection] = useState(1);

  const segments = [segmentFrom, segmentTo];

  return animationData.json ? (
    <Lottie
      className={
        !customClass
          ? `${!isMobileDevice ? styles.container : styles.containerMobile}`
          : customClass
      }
      loop={loop}
      play={play}
      speed={speed}
      goTo={goTo}
      direction={direction}
      segments={segmentsEnabled && segments}
      animationData={animationData.data}
    />
  ) : (
    <Lottie
      className={
        !customClass
          ? `${!isMobileDevice ? styles.container : styles.containerMobile}`
          : customClass
      }
      loop={loop}
      play={play}
      speed={speed}
      goTo={goTo}
      direction={direction}
      segments={segmentsEnabled && segments}
      path={
        isMobileDevice
          ? eventDetails.bannerLottieMobile && eventDetails.bannerLottieMobile
          : eventDetails.bannerLottieDesktop && eventDetails.bannerLottieDesktop
      }
    />
  );
};

export default BannerLottie;
